import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export function useMenuTransform() {
  const { t } = useI18n()
  const itemCounter = ref(0)

  const transformMenuItem = (item, parentKey = '') => {
    const currentKey = `${parentKey}_${itemCounter.value++}`

    const transformed = {
      key: currentKey,
      originalKey: item.route || item.name,
      label: item.isRawName ? item.label || item.name : t(item.name),
      icon: item.icon ? `pi pi-${item.icon}` : undefined,
      route: item.route,
      hasChildren: !!(item.children && item.children.length > 0),
      openInNewTab: item.openInNewTab,
    }

    if (item.children && item.children.length > 0) {
      transformed.children = item.children.map(child =>
        transformMenuItem(child, currentKey),
      )
    }

    return transformed
  }

  const transformMenuItems = (filteredItems) => {
    itemCounter.value = 0

    const allItems = [
      ...filteredItems.core.map(item => transformMenuItem(item, 'core')),
    ]

    if (filteredItems.core.length > 0 && filteredItems.modules.length > 0) {
      allItems.push({
        separator: true,
        key: 'separator',
      })
    }

    allItems.push(
      ...filteredItems.modules.map(item => transformMenuItem(item, 'modules')),
    )

    return allItems
  }

  return {
    transformMenuItems,
  }
}
